import styled from 'styled-components'
import { CLIENT_STYLINGS, size } from '../../../../utils/constants'
import { getBorderRadius, getShadow } from '../../../../utils/styleUtils'

export const GridWrapper = styled.div`
  background-color: transparent;
  width: 100%;
`

export const ItemImageWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  filter: ${props => {
    return props?.isHovered ? 'brightness(75%)' : 'brightness(80%)'
  }}; /* Adjust the percentage to control brightness */

  transform: ${props => {
    return props?.isHovered ? 'scale(1.025)' : 'scale(1)'
  }};

  cursor: ${props => {
    return props?.isHovered ? 'pointer' : 'default'
  }};

  &:hover {
    filter: ${props => {
      return props?.isHovered ? 'brightness(75%)' : 'brightness(80%)'
    }}; /* Adjust the percentage to control brightness */
    transform: scale(1.025);
    cursor: pointer;
  }
`

export const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: ${size.laptop}) {
    justify-content: space-around;
  }
`

export const GridItemWrapper = styled.a`
  width: ${props => {
    return props?.itemsPerRow === 3 ? '32%' : '48%'
  }};
  margin-right: 1.25%;
  margin-bottom: 15px;

  @media (max-width: ${size.tablet}) {
    width: 100%;
    margin-left: 0;
    margin-right: 0px;
  }
`

export const GridItemDetailsWrapper = styled.div`
  border: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  border-radius: ${props => getBorderRadius(props, 'lg')};
  box-shadow: ${props => getShadow(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
  position: relative;
  height: 300px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const ItemImage = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-image: url(${({ backgroundImage }) =>
      `"${encodeURI(backgroundImage)}"`}),
    url(${({ backgroundImage }) => `"${backgroundImage}"`});
  background-size: cover;
  background-position: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: end;
`

export const TripDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100px;
  justify-content: flex-end;
  position: relative;
`

export const TripSecondaryDetailsWrapper = styled.div`
  margin-right: 5px;
  margin-bottom: 0px;
  padding: 0px 10px 15px 10px;
  display: flex;
  flex-direction: row;
  position: relative;
  text-align: left;
  flex-direction: column;
`
export const TripSecondaryDetailsItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  @media (max-width: ${size.laptop}) {
    flex-direction: column;
  }
`
export const TripAvailibilty = styled.div`
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-weight: 700;
  width: 70%;

  @media (max-width: ${size.laptop}) {
    width: 100%;
  }
`

export const TripAvailibiltyText = styled.span`
  text-decoration: underline;
`

export const TripAvailibiltyIcon = styled.svg`
  position: absolute;
  top: 2px;
  width: 16px;
  height: 16px;

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  margin-left: ${props => {
    return props?.isHovered ? '5px' : '2px'
  }};
`

export const TripPrice = styled.span`
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-weight: 700;

  width: 30%;

  @media (max-width: ${size.laptop}) {
    width: 100%;
  }
`

export const TitleWrapper = styled.div`
  width: fit-content;
  padding: 0px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: transparent;
  text-align: left;
  padding-bottom: 5px;
`

export const Title = styled.h3`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 18px;
  font-weight: 700;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: left;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_TITLE_TEXT_TRANSFORM};
`

export const Location = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 20px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  right: 0px;
  line-height: 24px;
  font-weight: 700;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_LOCATION_TEXT_TRANSFORM};
`

export const GridTitle = styled.h2`
  position: inherit;
  top: unset;
  right: unset;
  background-color: unset;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-size: 20px;
  line-height: 30px;
  font-weight: 800;
  margin: 20px 0 15px;
  text-transform: uppercase;
  text-align: ${props => {
    return props?.isChatMode ? 'center' : 'left'
  }};

  @media (max-width: ${size.tablet}) {
    font-size: 16px;
    line-height: 20px;
    margin: 20px 0 15px;
  }
`

export const GridSubtitle = styled.h2`
  position: inherit;
  top: unset;
  right: unset;
  background-color: unset;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  margin: 15px 0px 25px 0px !important;
  padding: ${props => {
    return props?.isChatMode ? '0px 15px 0px 15px' : '0px'
  }};
  text-align: ${props => {
    return props?.isChatMode ? 'center' : 'left'
  }};
  text-align: center;
  font-style: italic;

  @media (max-width: ${size.tablet}) {
    font-size: 14px;
    line-height: 20px;
    margin: 15px 0px 25px 0px !important;
  }
`

export const TripTypeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  text-decoration: none;
`

export const TripTypeSeparator = styled.div`
  padding: 0px 3px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
`

export const TripTypeOnCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding-bottom: 10px;
  text-align: center;
  font-size: 12px;
  font-weight: 300;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  text-transform: lowercase;

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`

export const ShowMoreCta = styled.button`
  display: flex;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 7px 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  bottom: 0px;
  margin: 15px auto;
  align-self: stretch;

  @media (max-width: ${size.laptop}) {
    font-size: 14px;
  }

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    background-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`
